import { useFeatureFlags } from '@context/launch-darkly/LDProvider';

import { IBuyButtonProps } from '..';

import { useHandleAddToCartDeprecated } from './useHandleAddToCartDeprecated';
import { useHandleAddToCartNew } from './useHandleAddToCartNew';

export const useHandleAddToCart = (props: IBuyButtonProps) => {
  const { newAddToCartEndpoint } = useFeatureFlags();
  const handleAddToCart = useHandleAddToCartNew(props);
  const handleAddToCartDeprecated = useHandleAddToCartDeprecated(props);

  return newAddToCartEndpoint ? handleAddToCart : handleAddToCartDeprecated;
};
